/* eslint-env browser */

'use strict';

function onDomEvent(node, type, listener) {
  if (node.addEventListener) {
    node.addEventListener(type, listener, false);
    return true;
  } else if (node.attachEvent) {
    node[`e${type}${listener}`] = listener;
    node[type + listener] = function() {
      node[`e${type}${listener}`](window.event);
    };
    node.attachEvent(`on${type}`, node[type + listener]);
    return true;
  }
  return false;
}

const logError = (error, moduleName) => {
  if (process.env.NODE_ENV === 'production') {
    if (window.OptimizeSuite && window.OptimizeSuite.TrackingHub) {
      window.OptimizeSuite.TrackingHub.add('DealPage-FrontEndInit-Error', {
        error,
      });
    }
  } else {
    console.error(`module ${moduleName} failed to initialize`); // eslint-disable-line no-console
    console.error(error); // eslint-disable-line no-console
  }
};

const scheduleJs = (fn, timeout = 1000) => {
  if (process.env.NODE_ENV !== 'production') {
    if (window.payload.nodeEnv === 'test') {
      return fn();
    }
  }
  const initIfPageLoaded = () => {
    if (!document.readyState || document.readyState === 'complete') {
      fn();
    } else {
      scheduleJs(fn, timeout);
    }
  };

  if (window.requestIdleCallback) {
    window.requestIdleCallback(initIfPageLoaded, { timeout });
  } else {
    window.setTimeout(initIfPageLoaded, 0);
  }
};

const makeInitModule = payload => {
  // TODO: refactor modules to remove done()
  const doneShim = () => {};
  return (module, name) => {
    try {
      return module.init(payload, doneShim);
    } catch (e) {
      logError(e, name);
    }
  };
};

/*
  Initialize Frontend Javascript
  - jsInitializer is immediately invoked so only one instance exists on page
*/
const jsInitializer = (() => {
  const payload = window.payload;
  if (!payload || !payload.jsInitializer) {
    return;
  }

  const criticalJS = new Map();
  const pageReadyJS = new Map();
  const nonCriticalJS = new Map();

  const initModule = makeInitModule(payload);
  const initialize = () => {
    criticalJS.forEach(initModule);
    scheduleJs(() => nonCriticalJS.forEach(initModule));
  };

  onDomEvent(window, 'load', () => {
    pageReadyJS.forEach(initModule);
  });

  const { finalJsFile, moduleList } = payload.jsInitializer;
  const modulesToInit = new Map(moduleList.map(file => [file, true]));
  const shouldInit = initName => initName === finalJsFile;
  const addToMap = (currentMap, newFiles) => {
    newFiles.forEach(({ name, module }) => {
      if (modulesToInit.has(name)) {
        currentMap.set(name, module);
      }
    });
  };

  return {
    /*
      add module objs to be executed

      @params {array} [crit] - critical js to be immediately executed
      @params {array} [nonCrit] - js that when be executed when the browser is idle
      @params {array} [pageReady] - js used to mark t_done, etc
    */
    addJsFiles(crit = [], nonCrit = [], pageReady = []) {
      addToMap(criticalJS, crit);
      addToMap(nonCriticalJS, nonCrit);
      addToMap(pageReadyJS, pageReady);

      return this;
    },

    /*
      check if we're ready to initialize all passed-in JS

      @params {string} [initName]
        - name of js file, e.g. "responsive_local"
        - should be the last Deal Page file loaded
    */
    initIfReady(initName) {
      if (shouldInit(initName)) {
        initialize();
      }

      return this;
    },
  };
})();

module.exports = jsInitializer;
